const BASE = '/api/v1';
const BASE_URL = import.meta.env.VITE_BACKEND_URL;

export const API_ROUTES = {
  auth: {
    me: `${BASE}/users/me`,
    login: `${BASE}/authentication/login`,
    logout: `${BASE}/authentication/logout`,
    microsoftLogin: `${BASE_URL}${BASE}/authentication/microsoft_v2_auth`,
  },
  chat: {
    list: (trainNumber: string, journeyDate: string, forPdf: boolean) =>
      `${BASE}/chat/trains/${journeyDate}/${trainNumber}/chat_messages?for_pdf=${forPdf}`,
    predefinedMessagesByCategory: (id: number) =>
      `${BASE}/chat/predefined_message_categories/${id}/predefined_messages`,
    predefinedMessagesCategories: `${BASE}/chat/predefined_message_categories`,
  },
  commandForm: {
    create: `${BASE}/command_forms`,
    delete: (id: string) => `${BASE}/command_forms/${id}/revoke`,
    list: (today: string, trainNumber: string) => `${BASE}/command_forms/${today}/${trainNumber}`,
    detail: (id: string) => `${BASE}/command_forms/${id}`,
    timeline: `${BASE}/command_forms/timeline`,
    update: (id: string) => `${BASE}/command_forms/${id}/update_form_4`,
  },
  predefinedMessages: {
    list: `${BASE}/predefined_messages`,
    detail: (id: number) => `${BASE}/predefined_messages/${id}`,
  },
  predefinedMessageCategories: {
    list: `${BASE}/predefined_message_categories`,
    detail: (id: number) => `${BASE}/predefined_message_categories/${id}`,
  },
  trains: {
    list: `${BASE}/trains`,
    activeTrainNumbers: `${BASE}/trains/active_train_numbers`,
    pin: (id: string) => `${BASE}/trains/${id}/pin`,
    unpin: (id: string) => `${BASE}/trains/${id}/unpin`,
  },
  train_routes: {
    filterOptions: `${BASE}/train_routes`,
  },
  users: {
    list: `${BASE}/users`,
    detail: (id: string) => `${BASE}/users/${id}`,
    switchRole: `${BASE}/users/me/change_active_role`,
    selectRole: `${BASE}/users/me/select_role`,
  },
  commandFormTemplates: {
    list: `${BASE}/command_form_templates`,
    create: `${BASE}/command_form_templates`,
    detail: (id: string) => `${BASE}/command_form_templates/${id}`,
    update: (id: string) => `${BASE}/command_form_templates/${id}`,
    delete: (id: string) => `${BASE}/command_form_templates/${id}`,
    relatedTrains: (id: string) => `${BASE}/command_form_templates/${id}/related_trains`,
  },
  stations: {
    list: `${BASE}/stations`,
  },
  trainNetworkData: {
    list: `${BASE}/train_network_data`,
  },
} as const;
